// extracted by mini-css-extract-plugin
export default {"tool":"nbT5V6pmlK","icon":"bbVwwdJtrh","header":"FjY61vmNG_","body":"a4pPFLWL_7","name":"mKMO8pjtuc","description":"QJdOTOjpjP","dark":"SLqIA3GqSJ"};